import styled from 'styled-components';

export default styled.h1`
  padding: 18px 0 22px;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  box-sizing: border-box;

  @media ${(p) => p.theme.device.laptop} {
    margin: 0;
    padding: 55px 0;
    font-size: 30px;
    font-weight: 400;
  }
`;
